import { TourProps } from 'antd'
import { createContext } from 'react'

export type WizardContextType = {
  refStepOne: React.RefObject<HTMLDivElement>
  refStepTwo: React.RefObject<HTMLAnchorElement>
  refStepThree: React.RefObject<HTMLAnchorElement>
  refStepFour: React.RefObject<HTMLDivElement>
  refStepFive: React.RefObject<HTMLDivElement>
  refStepSix: React.RefObject<HTMLAnchorElement>
  open: boolean
  steps: TourProps['steps']
  current: number
  isLoading: boolean
  isBrokerAdmin: boolean
  setOpen: (open: boolean) => void
  onChangeStep: (step: number) => void
}

export const WizardContext = createContext<WizardContextType | undefined>(
  undefined
)
